import fetch from '@/plugin/axios'

// 新增大赛
export function addContest (query) {
  return fetch({
    url: '/api/order/megagame/add',
    method: 'Post',
    data: query
  })
}

// 大赛列表
export function megagameList (query) {
  return fetch({
    url: '/api/order/megagame/list',
    method: 'Post',
    data: query
  })
}

// 大赛详情
export function megagameInfo (id) {
  return fetch({
    url: `/api/order/megagame/info/${id}`,
    method: 'Get'
  })
}

// 修改大赛
export function megagameUpdate (id, query) {
  return fetch({
    url: `/api/order/megagame/update/${id}`,
    method: 'Post',
    data: query
  })
}
// 开启活动
export function megagameOpen (id) {
  return fetch({
    url: `/api/order/megagame/open/${id}`,
    method: 'Get'
  })
}

// 关闭活动
export function megagameClose (id) {
  return fetch({
    url: `/api/order/megagame/close/${id}`,
    method: 'Get'
  })
}
// 分类列表
export function megagameClassify (query) {
  return fetch({
    url: `/api/order/megagame-classify/list`,
    method: 'Post',
    data: query

  })
}
// 删除分类
export function megagameClassifyRemove (id) {
  return fetch({
    url: `/api/order/megagame-classify/remove/${id}`,
    method: 'Get'
  })
}

// 修改分类
export function megagameClassifyUpdate (id, query) {
  return fetch({
    url: `/api/order/megagame-classify/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 添加分类
export function megagameClassifyAdd (query) {
  return fetch({
    url: `/api/order/megagame-classify/add`,
    method: 'Post',
    data: query
  })
}

// 分类信息
export function megagameClassifyinfo (id) {
  return fetch({
    url: `/api/order/megagame-classify/info/${id}`,
    method: 'Get'
  })
}

// 选项列表megagame-classify/options
export function megagameClassifyOptions () {
  return fetch({
    url: `/api/order/megagame-classify/options`,
    method: 'get'
  })
}
